module.exports = __webpack_public_path__ + "img/10.f70c11c1.jpg";